import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isExclusiveBankStaffRoles } from '@toybank/ui';
import { AppStore } from './store';

/** The server still checks the exact bank-org grant on each prepare and confirm request. */
export const bankAuthorityGuard: CanActivateFn = () => {
  const store = inject(AppStore);
  const user = store.user();
  if (!user || isExclusiveBankStaffRoles(user.roles)) return true;
  return inject(Router).createUrlTree(['/customer-access-refused']);
};
